<div class="modal-header">
  <h1 color="black">Regras de Validação de Password</h1>
</div>
<div class="modal-body">
  <div class="row no-padding">
    <div class="col-md-12">
      <ul class="disc">
        <li>Número mínimo de caracteres: <strong>10</strong></li>
        <li>Número mínimo de caracteres alfabéticos em minúsculos: <strong>1</strong></li>
        <li>Número mínimo de caracteres alfabéticos em maiúsculos: <strong>1</strong></li>
        <li>Número mínimo de caracteres numéricos: <strong>1</strong></li>
        <li>Número mínimo de caracteres especiais ({{ specielCharacters }}): <strong>1</strong></li>
        <li>Número máximo de espaços: <strong>0</strong></li>
        <li>
          Não pode conter certas palavras ou caracteres: <strong>{{ keyWord }}</strong>
        </li>
        <li>Não pode ter mais que dois caracteres iguais seguidos</li>
        <li>Na alteração/recuperação de password a nova não pode ser igual à atual</li>
        <li>Número mínimo de regras do tipo de caracteres que devem ser preenchidos: <strong>Todos</strong></li>
      </ul>
    </div>
  </div>
</div>
<div class="dsm34--d-flex dsm34--justify-content-center">
  <button type="button" class="edp-btn btn-gray">Fechar</button>
</div>
